import { overlays } from '@ecosystem/newron-design-system';
import React, { useContext } from 'react';

import { NotificationToastType } from '../../common';
import { UpsellContext } from '../../state';
import { setNotificationMessage } from '../../state/action';

const { Toast } = overlays;

export const Notification = (): JSX.Element => {
  const {
    dispatch,
    state: { notification },
  } = useContext(UpsellContext);

  const toastNotification = notification || { message: '', type: NotificationToastType.Info };

  return (
    toastNotification.message !== '' && (
      <Toast
        type={toastNotification.type}
        onDismiss={() => dispatch(setNotificationMessage())}
        onComplete={() => dispatch(setNotificationMessage())}
      >
        {toastNotification.message}
      </Toast>
    )
  );
};
